import Barcode from "react-barcode";
import { convertToJalaliWithTime, convertToJalaliWithoutTime, formatDate } from "../../../tools/tools";
import "./printDocument.scss";
import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
// eSIM sales form. ponytail: copy of the physical form until the business unit sends the eSIM template
const PrintDocumentEsim = ({ print, lang = "fa", canvas = false, value }) => {
  const [msisdn, setMsisdn] = useState("0");
  const [language, setLanguage] = useState("");

  const [isCanvas, setIsCanvas] = useState(false);
  const myref = useRef("");
  useEffect(() => {
    if (print?.spMsisdn?.length > 0) {
      setMsisdn((print?.spMsisdn[0]?.msisdn || 0).toString());
    }
    setLanguage(lang);
    if (canvas) {
      setIsCanvas(true);
    }
  }, [print, lang, canvas]);

  useEffect(() => {
    if (isCanvas) {
      html2canvas(myref?.current).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        value(imgData); // Save the canvas image in the component's state
      });
    }
  }, [isCanvas]);
  return (
    <>
      <div ref={myref} className={`${isCanvas ? "canvas-document" : ""}`}>
        {language === "fa" ? (
          <div className="print-document-sp">
            <div className="sp-header">
              <div className="row-header">
                <div className="holder-right-head">
                  <div className="holder-row-right">
                    <div className="logo-text-hold">
                      <div className="hold-logo">
                        <img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
                      </div>
                      <div className="hold-text">
                        <h3>
                          فــــــرم ثــــبــــت نــــــام
                          <br />
                          eSIM {print?.spbundle?.bundleType === 1 ? <>دائمی</> : <>اعتباری</>} آپتل
                        </h3>
                      </div>
                    </div>
                    <div className="barcode-hold">
                      <p>بارکد و شماره MSISDN مشترک</p>
                      <div className="hold-img">
                        <Barcode displayValue={false} width={0.9} margin={0} height={30} font="IRANSansX" value={msisdn} />
                      </div>
                      <h3>{print?.spMsisdn?.length > 0 && print?.spMsisdn[0]?.msisdn}</h3>
                    </div>
                  </div>
                </div>
                <div className="holder-left-head">
                  <p>آپتل، برندتجاری شرکت نگین ارتباطات آوا، دارنده مجوز از سازمان تنظیم مقررات و ارتباطات رادیویی به شماره 10010012</p>
                  <div className="holder-row">
                    <div className="item">شماره ثبت: 11484</div>
                    <div className="item">شماره ملی: 14006277824</div>
                    <div className="item">کداقتصادی: 411518456919</div>
                  </div>
                  <div className="holder-list">
                    <ul>
                      <li>
                        <div className="label">دفترمرکزی: زنجان، پارک علم و فناوری، دانشگاه علوم پایه شماره 307</div>
                        <div className="value">
                          تلفن : <span dir="ltr">024 3315 4 307</span>
                        </div>
                      </li>
                      <li>
                        <div className="label">دفتـــر تــهــــران: خــیـابـــان ولــیــعــصــر، خــیابــان مــهــنــاز، پــلــــاک 8</div>
                        <div className="value">
                          تلفن : <span dir="ltr">021 7111 7 000</span>
                        </div>
                      </li>
                      <li>
                        <div className="label">
                          <span dir="ltr">info@aptel.ir</span>
                        </div>
                        <div className="value">
                          <span dir="ltr">www.aptel.ir</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="under-header">
              <div className="row-under">
                <div className="item">1-پاسخ به تمامی قسمت های * الزامی است.</div>
                <div className="item">2- یک نسحه از این برگه متعلق به خریداراست.</div>
                <div className="item">3-تکمیل فرم ثبت نام با درج شماره سیم کارت و ارائه کارت ملی الزامی است.</div>
              </div>
            </div>
            <div className="holder-body">
              <div className="holder-item-border">
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">* شماره تلفن همراه</div>
                      <div className="value">
                        <span dir="ltr">{print?.spMsisdn?.length > 0 && print?.spMsisdn[0]?.msisdn}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">*شماره کیت سیم کارت</div>
                      <div className="value">
                        <span dir="ltr">{print?.spKit}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">تاریخ تکمیل فرم</div>
                      <div className="value">
                        <span dir="ltr">{convertToJalaliWithTime(new Date().toISOString())}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">نام</div>
                      <div className="value">{print?.profile?.fname}</div>
                    </li>
                    <li>
                      <div className="label">نام خانوادگی</div>
                      <div className="value">{print?.profile?.lname}</div>
                    </li>
                    <li>
                      <div className="label">نام پدر</div>
                      <div className="value">{print?.profile?.fathername}</div>
                    </li>
                    <li>
                      <div className="label">کدملی/شماره گذرنامه</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.certno}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">تاریخ تولد</div>
                      <div className="value">{convertToJalaliWithoutTime(print?.profile?.birthdate)}</div>
                    </li>
                    <li>
                      <div className="label">نام پدر</div>
                      <div className="value">{print?.profile?.fathername}</div>
                    </li>
                    <li>
                      <div className="label">ملیت</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.txtCountry}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">جنسیت</div>
                      <div className="value">{print?.profile?.gender === 1 ? "مرد" : "زن"}</div>
                    </li>
                    <li>
                      <div className="label">پست الکترونیکی</div>
                      <div className="value">{print?.profile?.email}</div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">کدپستی ده رقمی</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.postalcode}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">استان</div>
                      <div className="value">{print?.profile?.txtProvince}</div>
                    </li>
                    <li>
                      <div className="label">شهر/روستا</div>
                      <div className="value">{print?.profile?.txtCity}</div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">خیابان/کوچه</div>
                      <div className="value">{print?.profile?.mainstreet}</div>
                    </li>
                    <li>
                      <div className="label">پلاک</div>
                      <div className="value">{print?.profile?.buildingno}</div>
                    </li>
                    <li>
                      <div className="label">طبقه</div>
                      <div className="value">{print?.profile?.floor}</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="holder-borderd">
                <div className="item-question">
                  مایلید ارتباط آپتل با شما از چه طریقی باشد :
                  <label>
                    پیامک <input type="checkbox" />{" "}
                  </label>
                  <label>
                    ایمیل <input type="checkbox" />{" "}
                  </label>
                  <label>
                    نرم افزار آپتل <input type="checkbox" />{" "}
                  </label>
                  <label>
                    سامانه حساب کابری aptel.my
                    <input type="checkbox" />{" "}
                  </label>
                </div>
              </div>
              <div className="holder-borderd">
                <div className="item">
                  راه هــای ارتباطــی بــا آپـتل: شمــارهــای مرکــز تمــاس مشتـرکیـن از سیــم کارت‌های آپـتل: شمــاره رایــگان 100 و از سایــر خطوط:{" "}
                  <span dir="ltr"> 0999 10 00 000 </span>
                  وب ســایت آپتــل بـه نشانـــی
                  <br />
                  <span dir="ltr">www.aptel.ir</span> و پســت الکتــرونــیــکــی <span dir="ltr">info@aptel.ir</span> و کــلیــه دفــاتر نمــایندگــی
                  منــدرج در وب سایــت آپتــل
                </div>
                <div className="item">
                  اینجانب ................................................... خریدار سیم کارت با مشخصات فوق الذکر اذعان و اقرار می نمایم که قوانین و
                  شرایط مندرج در قرارداد مشترکین مورد تایید سازمان تنظیم مقررات و ارتباطات رادیویی کشور را در سایت آپتل به نشانی{" "}
                  <span dir="ltr">www.aptel.ir</span> مطالعه نموده ام و از مفاد آن آگاهی کامل دارم و هیچ گونه اعتراضی درحال و آینده نخواهم داشت و از
                  این سیم کارت جهت هرگونه اعمال خلاف قوانین و مصوبات سازمان تنظیم مقررات و ارتباطات رادیویی کشور استفاده نمی نمایم.
                  <ul>
                    <li>
                      <div className="label">امضاء متقاضی:</div>
                      <div className="value"></div>
                    </li>
                    <li>
                      <div className="label">اثر انگشت متقاضی:</div>
                      <div className="value"></div>
                    </li>
                    <li>
                      <div className="label">تاریخ:</div>
                      <div className="value"></div>
                    </li>
                    <li>
                      <div className="label">مهر فروشگاه/فروشنده:</div>
                      <div className="value">کد شعبه نمایندگی: {print?.branchcode}</div>
                    </li>
                  </ul>
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="print-document-sp" dir="ltr">
            <div className="sp-header">
              <div className="row-header">
                <div className="holder-right-head">
                  <div className="holder-row-right">
                    <div className="logo-text-hold">
                      <div className="hold-logo">
                        <img src={process.env.PUBLIC_URL + "/assets/images/logo-small.png"} alt="" />
                      </div>
                      <div className="hold-text">
                        <h3>
                          Registration Form
                          <br />
                          eSIM {print?.spbundle?.bundleType === 1 ? <>postpaid</> : <>prepaid</>} Aptel
                        </h3>
                      </div>
                    </div>
                    <div className="barcode-hold">
                      <p>MSISDN barcode and number</p>
                      <div className="hold-img">
                        <Barcode displayValue={false} width={1.1} margin={0} height={30} font="IRANSansX" value={msisdn} />
                      </div>
                      <h3>{print?.spMsisdn?.length > 0 && print?.spMsisdn[0]?.msisdn}</h3>
                    </div>
                  </div>
                </div>
                <div className="holder-left-head">
                  <p>Aptel is a commercial brand of "Negin Ertebatat Ava" Co, licensed by the CRA number1001001</p>

                  <div className="holder-list">
                    <ul>
                      <li>
                        <div className="label">Registration NO: </div>
                        <div className="value">
                          <span dir="ltr">11484</span>
                        </div>
                      </li>
                      <li>
                        <div className="label">Tehran office:NO 8 , Mahnaz St., Valiasr St</div>
                        <div className="value">
                          TEL : <span dir="ltr">021 7111 7 000</span>
                        </div>
                      </li>
                      <li>
                        <div className="label">
                          <span dir="ltr">info@aptel.ir</span>
                        </div>
                        <div className="value">
                          <span dir="ltr">www.aptel.ir</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="under-header">
              <div className="row-under">
                <div className="item">1- One copy of this sheet belongs to the customer.</div>
                <div className="item">2- Completing the registration form & presenting an identification document is mandatory</div>
              </div>
            </div>
            <div className="holder-body">
              <div className="holder-item-border">
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">SIM card NO</div>
                      <div className="value">
                        <span dir="ltr">{print?.spMsisdn?.length > 0 && print?.spMsisdn[0]?.msisdn}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">KIT No</div>
                      <div className="value">
                        <span dir="ltr">{print?.spKit}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">Registration date</div>
                      <div className="value">
                        <span dir="ltr">{formatDate(new Date().toISOString())}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">Name:</div>
                      <div className="value">{print?.profile?.fname}</div>
                    </li>
                    <li>
                      <div className="label">Surname:</div>
                      <div className="value">{print?.profile?.lname}</div>
                    </li>

                    <li>
                      <div className="label">National ID/Passport:</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.certno}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">Date Of Birth:</div>
                      <div className="value">{formatDate(print?.profile?.birthdate)}</div>
                    </li>
                    <li>
                      <div className="label">Father Name:</div>
                      <div className="value">{print?.profile?.fathername}</div>
                    </li>
                    <li>
                      <div className="label">Nationality:</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.txtCountry}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">Gender:</div>
                      <div className="value">{print?.profile?.gender === 1 ? "Male" : "Famale"}</div>
                    </li>
                    <li>
                      <div className="label">Email:</div>
                      <div className="value">{print?.profile?.email}</div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">Postal Code:</div>
                      <div className="value">
                        <span dir="ltr">{print?.profile?.postalcode}</span>
                      </div>
                    </li>
                    <li>
                      <div className="label">Province:</div>
                      <div className="value">{print?.profile?.txtProvince}</div>
                    </li>
                    <li>
                      <div className="label">City/village</div>
                      <div className="value">{print?.profile?.txtCity}</div>
                    </li>
                  </ul>
                </div>
                <div className="item">
                  <ul>
                    <li>
                      <div className="label">Floor</div>
                      <div className="value">{print?.profile?.floor}</div>
                    </li>
                    <li>
                      <div className="label">Plaque/Block</div>
                      <div className="value">{print?.profile?.buildingno}</div>
                    </li>
                    <li>
                      <div className="label">Avenue/the all</div>
                      <div className="value">{print?.profile?.mainstreet}</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="holder-borderd">
                <div className="item-question">
                  How would you like Aptel to communicate with you?
                  <label>
                    <input type="checkbox" /> SMS
                  </label>
                  <label>
                    <input type="checkbox" /> Email
                  </label>
                  <label>
                    <input type="checkbox" /> Software Aptel
                  </label>
                  <label>
                    <input type="checkbox" /> Account system my.aptel
                  </label>
                </div>
              </div>
              <div className="holder-borderd">
                <div className="item">
                  Contact Us:
                  <br />
                  Free Number : 100 (By Your SIM card) 09991000000 www.aptel.ir info@aptel.ir
                </div>
                <div className="item">
                  I confirm ................................................... that the purchase and registration of the SIM card was done
                  personally& I hereby confirmed above information & declared that I have read the subscriber rules and conditions in the agreement on
                  the Aptel website at WWW.aptel.ir .I will not use this SIM card for any actions against the IRR laws. .
                  <ul>
                    <li>
                      <div className="label">Signature/fingerprint of the applicant : </div>
                      <div className="value"></div>
                    </li>
                    <li>
                      <div className="label">Date:</div>
                      <div className="value"></div>
                    </li>
                    <li>
                      <div className="label">stamp store/seller :</div>
                      <div className="value">Representative branch code: {print?.branchcode}</div>
                    </li>
                  </ul>
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PrintDocumentEsim;
